import axios from "axios";
import React, { useState, useEffect } from "react";
import CreaEquipoGerencia from "./CreaEquipo/CreaEquipoGerencia";
import Cookies from "universal-cookie";
import Swal from "sweetalert2";

function EquipoGerencia({ idSolicitud }) {
  const cookies = new Cookies();

  const [list, setList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  const url = window.location.href;
  const partesURL = url.split("/");
  const nombreRuta = partesURL[partesURL.indexOf("#") + 1];

  const obtenerDatos = () => {
    axios
      .get(
        `https://suadesarrollo.azurewebsites.net/api/ObtenerEquipoGerenciaPorSolicitudId?SolicitudId=${idSolicitud}`,
        {
          auth: {
            username: "BasicAuth@icontec.org",
            password: "yQLzqmR7eZSuAmQZUqhY",
          },
        },
      )
      .then((res) => setList(res.data))
      .catch((err) => console.error(err));
  };

  useEffect(() => {
    obtenerDatos();
  }, [idSolicitud]);

  const eliminarRegistro = (id) => {
    Swal.fire({
      title: "¿Eliminar registro?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, eliminar",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(
            `https://suadesarrollo.azurewebsites.net/api/eliminarEquipoGerenciaPorId?Id=${id}`,
            {
              auth: {
                username: "BasicAuth@icontec.org",
                password: "yQLzqmR7eZSuAmQZUqhY",
              },
              data: {
                tipoAccion: "Eliminación equipo gerencia",
                idUsuario: cookies.get("id"),
              },
            },
          )
          .then(() => {
            Swal.fire("Eliminado", "Registro eliminado", "success");
            obtenerDatos();
          })
          .catch(() => Swal.fire("Error", "No se pudo eliminar", "error"));
      }
    });
  };

  // 🔢 PAGINACIÓN
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = list.slice(indexOfFirstItem, indexOfLastItem);

  const totalPages = Math.ceil(list.length / itemsPerPage);

  const nextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  return (
    <div className="container">
      <div className="card shadow">
        <div className="card-header">
          <h6 className="text-primary font-weight-bold">Equipo Gerencia</h6>
        </div>

        <div className="card-body">
          {cookies.get("tipo_Usuario") == 2 &&
            nombreRuta === "ProcesoAutoevaluacion" && (
              <CreaEquipoGerencia
                idSolicitud={idSolicitud}
                onCreated={obtenerDatos}
              />
            )}

          <table className="table table-bordered mt-3">
            <thead>
              <tr>
                <th>Id</th>
                <th>Nombre</th>
                <th>Área</th>
                <th>Cargo</th>
                <th>Líder</th>
                <th>Antiguedad</th>
                <th>SolicitudId</th>
                <th>Acciones</th>
              </tr>
            </thead>
            <tbody>
              {currentItems.length > 0 ? (
                currentItems.map((item) => (
                  <tr key={item.id}>
                    <td>{item.id}</td>
                    <td>{item.nombre}</td>
                    <td>{item.area}</td>
                    <td>{item.cargo}</td>
                    <td>{item.antiguedad}</td>
                    <td>{item.lider}</td>
                    <td>{item.solicitudId}</td>
                    <td>
                      <button
                        className="btn btn-danger btn-sm"
                        onClick={() => eliminarRegistro(item.id)}
                      >
                        Eliminar
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="7" className="text-center">
                    No hay registros
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          {/* 🔥 PAGINADOR */}
          {list.length > itemsPerPage && (
            <div className="d-flex justify-content-between align-items-center mt-3">
              <button
                className="btn btn-secondary"
                onClick={prevPage}
                disabled={currentPage === 1}
              >
                ⬅ Anterior
              </button>

              <span>
                Página <strong>{currentPage}</strong> de{" "}
                <strong>{totalPages}</strong>
              </span>

              <button
                className="btn btn-primary"
                onClick={nextPage}
                disabled={currentPage === totalPages}
              >
                Siguiente ➡
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default EquipoGerencia;
